import React, { useEffect, useState } from "react";
import { Dropdown, Icon, IDropdownProps, ResponsiveMode } from "@fluentui/react";
import { FullPageModal } from "../layout/FullPageModal";
import { DEFAULT_FOLDER_CREATION } from "../document/WithApiFileLocationProvider";

interface InternalState {
  modalIsOpen: boolean;
}

export interface FullPageModalDropDownProps extends IDropdownProps {
  modalTitle: string;
  isOpen: boolean;
  selectedValue: string;
  scrollableContentStyle?: string;
}

const OnRenderCaretDown = () => <Icon iconName="More" />;

export const FullPageModalDropDown: React.FunctionComponent<FullPageModalDropDownProps> = (props) => {
  const [state, setState] = useState<InternalState>({ modalIsOpen: false });

  console.log("FullPageModalDropDown rendering with state", state);

  useEffect(() => {
    setState({ ...state, modalIsOpen: props.isOpen });
  }, [props]);

  return (
    <>
      <Dropdown
        {...props}
        onRenderCaretDown={OnRenderCaretDown}
        options={[]}
        onClick={() => setState({ ...state, modalIsOpen: true })}
        responsiveMode={ResponsiveMode.large}
        placeholder={props.selectedValue ? props.selectedValue : DEFAULT_FOLDER_CREATION}
      />
      <FullPageModal
        modalProps={{ isOpen: state.modalIsOpen, scrollableContentClassName: props.scrollableContentStyle }}
        onClose={() => setState({ ...state, modalIsOpen: false })}
        textTitle={props.modalTitle}
      >
        {props.children}
      </FullPageModal>
    </>
  );
};
